export default {
  acceptanceDetails: {
    dateRange: '检验日期范围',
    orderType: '订单性质',
    purchaseUnitNo: '采购中心',
    goodsNo: '料号',
    goodsName: '品名',
    spec: '规格',
    outInspectNo: '外部单号',
    searchPlaceholder: '商品名/检验单号/供应商',
    inspectNo: '检验单号',
    docDate: '检验日期',
    purOfficeName: '采购中心',
    supplierName: '供应商',
    remarks: '备注',
    inspectSeq: '项次',
    acceptQty: '验收数量',
    purUnitName: '单位',
    purchaseNo: '订单单号',
    purchaseSeq: '订单项次',
    purchasePhaseSeq: '订单项序'
  }
}
